module.exports = __webpack_public_path__ + "img/microphone.451ce2e3.svg";